import React from 'react';
import LevelingImage from './images/LevelingGround.png';
import WorkForceImage from './images/WorkForce.png';
import TasksImage from './images/Tasks.png';
import BossImage from './images/Icon_Battle.png';

function MenuBottom({changeActiveComponent, activeComponent}) {

  const isActive = (componentName) => {
    return activeComponent === componentName ? "active3" : "";
  };

  return (
    <div className="menu-bottom">
      <button className={`bottom-button leveling-b ${isActive('leveling')}`} onClick={() => changeActiveComponent('leveling')}> 
        <div className="bottom-button-imagecontainer"><img src={LevelingImage} alt="Leveling icon" /></div>
        <span>LEVELING</span>
      </button>
      <button className={`bottom-button tasks-b ${isActive('tasks')}`} onClick={() => changeActiveComponent('tasks')}>
      <div className="bottom-button-imagecontainer"><img src={TasksImage} alt="Tasks icon" /></div><span>TASKS</span>
      </button>
      <button className={`bottom-button workforce-b ${isActive('workforce')}`} onClick={() => changeActiveComponent('workforce')}>
      <div className="bottom-button-imagecontainer"><img src={WorkForceImage} alt="Workforce icon" /></div><span>WORKFORCE</span>
      </button>
      <button className={`bottom-button bosses-b ${isActive('bosses')}`} onClick={() => changeActiveComponent('bosses')}>
      <div className="bottom-button-imagecontainer"><img src={BossImage} alt="Boss fights icon" /></div><span>BOSS FIGHTS</span>
      </button>
    </div>
  );
}

export default MenuBottom;